import { constants, typographyStyles } from "@newsela/angelou";

import {
  annotationColors,
  annotationColorsDarker,
} from "@/view/AnnotatedText/AnnotatedText.constants";

const { colors } = constants;
const { fontSize } = typographyStyles;

export const labelCss = (color) => {
  return {
    ...fontSize.textS,
    paddingLeft: "20px",
    position: "relative",
    display: "flex",
    alignItems: "center",
    color: colors.ui.neutral[700],

    "&:before": {
      boxSizing: "border-box",
      position: "absolute",
      content: '""',
      height: "16px",
      width: "16px",
      borderBottom: `2px solid ${annotationColorsDarker[color]}`,
      backgroundColor: annotationColors[color],
      left: 0,
    },
  };
};
